<template>
  <el-dialog
    class="line-notify-dialog"
    :visible.sync="visibleDialog"
    width="335px"
    :close-on-click-modal="false"
    destroy-on-close
    append-to-body
  >
    <p class="mb-8">{{ $t('lineLink.content.notify') }}</p>

    <div class="text-center">
      <line-button @click="onClose">{{ $t('common.action.lineLink') }}</line-button>
      <div class="mt-8">
        <el-button type="text" @click="onClose">{{ $t('common.action.ok') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import LineButton from '@/components/LineButton.vue'

export default {
  name: 'NotifyDialog',

  components: {
    LineButton,
  },

  props: {
    visible: Boolean,
  },

  computed: {
    visibleDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },

  methods: {
    onClose() {
      this.visibleDialog = false
    },
  },
}
</script>
